import axios from 'axios';
import cfac22 from '../../cfac22';

const getRegisterResultPayload = (data) => {
  if (!data) return null;

  if (data.result && typeof data.result === 'object') return data.result;
  if (data.data && typeof data.data === 'object') return data.data;
  if (data.success && typeof data.success === 'object') return data.success;

  return data;
};

export const register = async (payload) => {
  console.log('REGISTER API - Payload:', payload);

  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/register`;

    const { data } = await axios.post(
      endpoint,
      { ...payload },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const success = data?.success === true || data?.status === true;
    const error = data?.error || data?.message;

    if (!success) {
      return {
        success: false,
        error: error || 'Erro ao realizar cadastro',
      };
    }

    const resultPayload = getRegisterResultPayload(data);
    const accessToken =
      resultPayload?.accessToken || resultPayload?.token || null;
    const sessionId = resultPayload?.sessionId || resultPayload?.sessionID || null;
    const userUId = resultPayload?.userUId || resultPayload?.userUid || resultPayload?.uId || null;

    if (!accessToken || !sessionId || !userUId) {
      return {
        success: false,
        error: 'Resposta de cadastro inválida.',
      };
    }

    return {
      success: true,
      data: {
        accessToken,
        sessionId,
        userUId,
      },
    };
  } catch (error) {
    console.error('REGISTER API - Error:', error);
    throw error?.response?.data || error;
  }
};
